window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600,
    addToCartRedirect: ({ cartItems, discountCode }) => {
      const openCartEvent = new Event("reloadCartAndOpen", { cartItems, discountCode });
      window.dispatchEvent(openCartEvent);
      const redirectUrl = window.awtomicRedirectUrl || "/cart";
      window.location.assign(`/discount/${discountCode}`);
      window.location.href = redirectUrl;
    }
  }
});

//cart rollup
document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});

//add banner to babs
if (window.location.href.includes("/tools/bundle-subscriptions/bundle/")) {
  const onHeaderLoaded = (header) => {
    const banner = document.createElement("div");
    banner.classList.add("awt-bundle-banner");

    const bundleSets = [
      [
        { id: "8444464496795", product: "build-your-bundle-5", label: "5 PACK" },
        { id: "8444469674139", product: "build-your-bundle-6", label: "6+ PACK" }
      ],
      [
        { id: "9887927632194", product: "build-your-bundle", label: "5 PACK" },
        { id: "9914330317122", product: "build-your-bundle-6", label: "6+ PACK" }
      ]
    ];

    const currentSet = bundleSets.find((set) => set.some(({ id }) => window.location.href.includes(id)));

    if (currentSet) {
      const currentBundle = currentSet.find(({ id }) => window.location.href.includes(id));

      const toggleDiv = document.createElement("div");
      toggleDiv.classList.add("toggle-div");

      toggleDiv.innerHTML = currentSet
        .map(
          ({ id, product, label }) => `
            <a href="/tools/bundle-subscriptions/bundle/${id}?product=${product}" class="${currentBundle.id === id ? "selected" : ""}">${label}</a>
          `
        )
        .join("");

      banner.appendChild(toggleDiv);

      const getQueryStringExcludingProduct = () => {
        const url = new URL(window.location);
        url.searchParams.delete("product");
        return url.search;
      };

      const updateBannersQuery = () => {
        setTimeout(() => {
          toggleDiv.childNodes.forEach((child) => {
            if (child.href) {
              const url = new URL(child.href);
              const newParams = new URLSearchParams(getQueryStringExcludingProduct());
              newParams.forEach((value, key) => {
                url.searchParams.set(key, value);
              });
              child.href = url.href;
            }
          });
        }, 20);
      };

      updateBannersQuery();

      setTimeout(() => {
        const plansContainer = document.querySelector(".awtomatic-plans-container");
        if (plansContainer) {
          plansContainer.addEventListener("click", (e) => {
            updateBannersQuery();
          });
        }
      }, 200);
    }

    header.appendChild(banner);
  };

  const checkHeaderLoaded = () => document.querySelector("header.bundleapp-modal__container--complete-screen--header-container") || false;

  if (!checkHeaderLoaded()) {
    const observer = new MutationObserver((mutations) => {
      if (checkHeaderLoaded()) {
        observer.disconnect();
        onHeaderLoaded(checkHeaderLoaded());
        return;
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    setTimeout(() => {
      observer.disconnect();
    }, 5000);
  } else {
    onHeaderLoaded(checkHeaderLoaded());
  }
}
